import React, { useState } from "react";
// @material-ui/core components
import { makeStyles } from '@material-ui/core/styles';

// core components
import GridItem from 'components/Grid/GridItem.js';
import Button from "components/CustomButtons/Button.js";
import styles from 'views/component/Styles.js';
import SimpleTable from 'views/component/SimpleTable.js';
import WorkCalendarPopup from "../WorkCalendarPopup";
import Clearfix from "components/Clearfix/Clearfix";

const useStyles = makeStyles(styles);

export default function WorkCalendar(props) {
    const { factory, onSave } = props;
    const classes = useStyles();
    const [openPop, setOpenPop] = useState(false);
    const [insertData, setInsertData] = useState([]);

    const handleSave = function (tempData) {
        if (onSave) {
            onSave(tempData);
        }
    }

    const handlePopSave = function (startDate, endDate, startTime, endTime) {
        const end = new Date(endDate);
        let temp = [];
        for (let date = new Date(startDate); date <= end; date.setDate(date.getDate() + 1)) {
            temp = [...temp, {
                factory_id: factory.factory_id, daily_date: date.toISOString().substr(0, 10),
                daily_start_time: startTime, daily_end_time: endTime
            }];
        }
        setInsertData(temp);
    }

    return (<GridItem xs={12} md={6} className={classes.collapsed}>
        <div className={classes.cellTitle}>
            <h4>Work Calendar</h4>
        </div>
        <div className={classes.cellContentAps}>
            <Button className={classes.left} onClick={e => setOpenPop(true)} color='infoOutline' size='sm'>일괄 입력</Button>
            <SimpleTable domain="aps" tableName="workCalendar" params={factory} insertAttr={factory} onSave={handleSave}
                insertData={insertData} droppable />
        </div>
        <WorkCalendarPopup modal={openPop} onSave={handlePopSave} onClose={() => setOpenPop(false)} />
    </GridItem>);
}